namespace TabAurous.Administration {
    export interface QualityInspectionTemplateForm {
        Code: Serenity.StringEditor;
        Details: QualityInspectionTemplateDetailsEditor;
    }

    export class QualityInspectionTemplateForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.QualityInspectionTemplate';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QualityInspectionTemplateForm.init)  {
                QualityInspectionTemplateForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = QualityInspectionTemplateDetailsEditor;

                Q.initFormType(QualityInspectionTemplateForm, [
                    'Code', w0,
                    'Details', w1
                ]);
            }
        }
    }
}
